/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190729 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { AppParameter } from 'src/app/_model/app-parameter';
import { Resetable } from '../../resetter/resetable';

@Injectable()
export abstract class AppParameterDaoService implements Resetable {
  public abstract saveAppParameters(appParameter: AppParameter): Promise<void>;
  public abstract getAppParameters(): Promise<AppParameter>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
